<style scoped>
.custom-file-upload {
  cursor: pointer;
  padding: 6px 12px;
  border: groove;
  background-color: #efefef;
  color: rgb(0, 0, 0);
  border-radius: 4px;
  display: inline-block;
  text-align: center;
}
.custom-file-upload:hover {
  background-color: #b1b1b1;
}
</style>

<template>
  <div class="upload-form">
    <h2>อัพโหลด เอกสาร</h2>
    <form @submit.prevent="handleUpload">
      <div class="form-group">
        <label for="distributor">ศูนย์จัดจำหน่าย:</label>
        <select v-model="selectedDistributor" @change="fetchSalesAndShops">
          <option disabled value="">--เลือกศูนย์จัดจำหน่าย--</option>
          <option v-for="distributor in distributors" :key="distributor.code" :value="distributor.name">
            {{ distributor.name }}
          </option>
        </select>
      </div>

      <div class="form-group">
        <label for="sales">ตัวแทน:</label>
        <select v-model="selectedSales">
          <option disabled value="">--เลือกตัวแทน--</option>
          <option v-for="sales in salesList" :key="sales" :value="sales">
            {{ sales }}
          </option>
        </select>
      </div>

      <div class="form-group">
        <label for="shop">ร้านค้า:</label>
        <input
          type="text"
          v-model="shopSearch"
          @input="filterShops"
          placeholder="--เลือกร้านค้า--"
        />
        <select v-model="selectedShop">
          <option disabled value="">--เลือกร้านค้า--</option>
          <option v-for="shop in filteredShops" :key="shop.code" :value="shop">
            {{ shop.name }}
          </option>
        </select>
      </div>

      <div class="form-group">
        <label for="shop-code">รหัสร้านค้า:</label>
        <input
          v-model="shopCode"
          id="shop-code"
          type="text"
          placeholder="ใส่รหัสร้านค้า หรือ เลือกจากรายชื่อร้านค้าด้านบน"
        />
      </div>

      <div>
        <label for="file">ไฟล์เอกสาร:</label>
        <!-- ใช้ label แทน input เริ่มต้น -->
        <label for="file-upload" class="custom-file-upload">
          เลือกไฟล์เอกสาร
        </label>
        <input
          type="file"
          id="file-upload"
          @change="handleFileChange"
          style="display: none;"
          required
        />
        <!-- แสดงชื่อไฟล์ที่เลือก -->
        <span>&nbsp;{{ fileName || "ยังไม่ได้เลือกไฟล์" }}</span>
      </div>

      <button type="submit">อัพโหลด</button>
      <p v-if="message" class="message">{{ message }}</p>
      <p v-if="errorMessage" class="error">{{ errorMessage }}</p>
    </form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      distributors: [],
      selectedDistributor: "",
      salesList: [],
      selectedSales: "",
      shops: [],
      filteredShops: [],
      shopSearch: "",
      selectedShop: null,
      shopCode: "",
      file: null,
      message: null,
      errorMessage: null,
      fileName: "",
    };
  },
  methods: {
    handleFileChange(event) {
      this.file = event.target.files[0];
      this.fileName = this.file ? this.file.name : "";
    },
    fetchDistributors() {
      fetch(`/api/distributors`)
        .then((response) => response.json())
        .then((data) => {
          this.distributors = data;
        })
        .catch((error) => {
          console.error("Error fetching distributors:", error);
        });
    },
    fetchSalesAndShops() {
      if (!this.selectedDistributor) return;

      // Fetch sales
      fetch(
        `/api/get_sales_by_distributor?distributor_name=${encodeURIComponent(
          this.selectedDistributor
        )}`
      )
        .then((response) => response.json())
        .then((data) => {
          this.salesList = data.sales_names || [];
        })
        .catch((error) => {
          console.error("Error fetching sales:", error);
        });

      // Fetch shops
      fetch(
        `/api/get_shop_by_distributor?distributor_name=${encodeURIComponent(
          this.selectedDistributor
        )}`
      )
        .then((response) => response.json())
        .then((data) => {
          this.shops = data.shops || [];
          this.filteredShops = this.shops;
        })
        .catch((error) => {
          console.error("Error fetching shops:", error);
        });
    },
    filterShops() {
      this.filteredShops = this.shops.filter(
        (shop) =>
          shop.name &&
          shop.name.toLowerCase().includes(this.shopSearch.toLowerCase())
      );
    },
    handleUpload() {
      if (!this.file) {
        this.errorMessage = "Please select a file to upload.";
        return;
      }

      const formData = new FormData();
      formData.append("file", this.file);
      formData.append("distributor_name", this.selectedDistributor);
      formData.append("sales_name", this.selectedSales);
      formData.append("shop_code", this.shopCode);

      fetch(`/api/upload`, {
        method: "POST",
        body: formData,
      })
        .then((response) => {
          if (response.ok) {
            return response.json();
          } else {
            throw new Error("Upload failed.");
          }
        })
        .then((data) => {
          this.message = "Transaction uploaded successfully!";
          this.errorMessage = null;
        })
        .catch((error) => {
          this.errorMessage = error.message;
          this.message = null;
        });
    },
  },
  watch: {
    selectedShop(newShop) {
      if (newShop) {
        this.shopCode = newShop.code; // Automatically populate the shop code
      }
    },
  },
  mounted() {
    this.fetchDistributors();
  },
};
</script>

<style scoped>
.upload-form {
  max-width: 500px;
  margin: auto;
}
.form-group {
  margin-bottom: 20px;
}
label {
  display: block;
  margin-bottom: 8px;
}
select,
input,
button {
  width: 100%;
  padding: 10px;
  box-sizing: border-box;
}
.message {
  color: green;
}
.error {
  color: red;
}
</style>

